<template>
    <div v-if="env !== 'production'" class="bankid-faker">
        <button
            :class="`bankid-faker__toggle ${isModalOpen ? 'bankid-faker__toggle--active' : ''} ${
                hasSession ? 'bankid-faker__toggle--active' : ''
            }`"
            @click="toggleModal"
        >
            <img class="bankid-faker__toggle__icon" src="/images/bankid.gif" alt="BankId" />
            <span class="bankid-faker__toggle__label">FAKER</span>
        </button>

        <div v-if="isModalOpen" class="bankid-faker__modal">
            <span class="bankid-faker__modal__close icon-circle-cross" @click="toggleModal"></span>

            <div class="bankid-faker__modal__header">
                <h2 class="bankid-faker__modal__title">BankID Faker</h2>
                <p>Use this tool to generate BankID responses instead of using BankID app.</p>
                <p>This tool is only used for develpment and testing and is not available in Production.</p>
                <p>
                    <a target="_blank" href="https://tedeh.net/tools/generator-for-swedish-personnummer/"
                        >Generate a valid Swedish Personnummer</a
                    >
                </p>
            </div>

            <form @submit.prevent="setDebugSession">
                <form-row>
                    <form-input
                        v-model="data.ssn"
                        label="Personnummer"
                        validators="required|ssn"
                        required="true"
                        type="text"
                        placeholder="ÅÅÅÅMMDD-XXXX"
                    />
                </form-row>

                <form-row>
                    <form-input
                        v-model="data.firstname"
                        label="First name"
                        validators="required"
                        required="true"
                        type="text"
                        placeholder="Enter a first name"
                    />
                </form-row>

                <form-row>
                    <form-input
                        v-model="data.lastname"
                        label="Last name"
                        validators="required"
                        required="true"
                        type="text"
                        placeholder="Enter a last name"
                    />
                </form-row>

                <div class="bankid-faker__modal__actions">
                    <a v-if="hasSession" class="bankid-faker__modal__action--cancel" @click="deleteDebugSession"
                        >Delete previous session</a
                    >
                    <button class="bankid-faker__modal__action btn btn--cta" @click="setDebugSession">Apply</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import { ref } from 'vue';
    import FormInput from '../Forms/types/FormInput';
    import FormRow from '../Forms/FormRow';
    import { deleteCookie, getCookie, setCookie } from '../../../helpers';

    export default {
        components: {
            FormInput,
            FormRow,
        },
        setup() {
            const env = process.env.NODE_ENV || 'development';
            const isModalOpen = ref(false);

            const cookie = getCookie('cervd_bankid_faker');
            const previousSession = cookie ? JSON.parse(cookie) || {} : {};

            const data = ref({
                ssn: previousSession.simulated_ssn || '',
                firstname: previousSession.simulated_firstname || '',
                lastname: previousSession.simulated_lastname || '',
            });

            const hasSession = ref(!!getCookie('cervd_bankid_faker'));

            const toggleModal = () => {
                isModalOpen.value = !isModalOpen.value;
            };

            const setDebugSession = () => {
                const ssn = data.value.ssn;
                const firstname = data.value.firstname;
                const lastname = data.value.lastname;

                if (ssn && firstname && lastname) {
                    hasSession.value = true;
                    setCookie(
                        'cervd_bankid_faker',
                        JSON.stringify({
                            simulated_ssn: ssn,
                            simulated_firstname: firstname,
                            simulated_lastname: lastname,
                        }),
                        30
                    );
                    toggleModal();
                }
            };

            const deleteDebugSession = () => {
                data.value.ssn = '';
                data.value.firstname = '';
                data.value.lastname = '';
                deleteCookie('cervd_bankid_faker');

                hasSession.value = false;
            };

            return {
                data,
                env,
                isModalOpen,
                hasSession,
                toggleModal,
                setDebugSession,
                deleteDebugSession,
            };
        },
    };
</script>
